<template>
  <div class="section py-0 px-5">
      <div class="tile app-title">
        <p class="subtitle is-6">Par disponibilité</p>
      </div>
    <section>
      <b-field class="tile is-vertical">
        <div>
            <a class="button is-disponible"
              @click="modifierDispo(disponible, 'estDisponible')"
              :disabled="!disponibiliteAvailability"
              :class="classBoutonDispo.estDisponible">
              Disponible</a> <br/>
            <a class="button is-warning"
              @click="modifierDispo(partiellementDispo, 'estPartiellementDisponible') "
              :disabled="!disponibiliteAvailability"
              :class="classBoutonDispo.estPartiellementDisponible">
              Partiellement disponible</a> <br/>
            <a class="button is-nondisponible"
              @click="modifierDispo(indisponible, 'estIndisponible')"
              :disabled="!disponibiliteAvailability"
              :class="classBoutonDispo.estIndisponible">
              Non disponible</a> <br/>
        </div>
      </b-field>
    </section>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteFacesLc-mutation-type';
import * as niveauDispo from '../../configuration/DisponibiliteConf';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');

export default {
  name: 'disponibilite',
  data() {
    return {
      classBoutonDispo: this.donneClassCssInitiale(),
    };
  },
  computed: {
    ...VenteFacesLc.mapGetters({
      disponibiliteAvailability: 'disponibiliteAvailability',
      filtres: 'filtres',
    }),
    disponibilite: {
      get() {
        if (this.filtres.dispo) {
          return this.filtres.dispo.valeur;
        }
        this.initialiseFiltreDispo([]);
        return this.disponibilite;
      },
      set(value) {
        this.initialiseFiltreDispo(value);
      },
    },
    disponible() {
      return niveauDispo.DISPONIBLE;
    },
    indisponible() {
      return niveauDispo.NON_DISPONIBLE;
    },
    partiellementDispo() {
      return niveauDispo.PARTIELLEMENT_DISPONIBLE;
    },
  },
  watch: {
    filtres() {
      if (this.disponibilite.length === 0) {
        this.classBoutonDispo = this.donneClassCssInitiale();
      }
    },
  },
  mounted() {
    const niveauDispo = ['estIndisponible', 'estPartiellementDisponible', 'estDisponible'];
    this.disponibilite.forEach((el) => {
      if (el === 1) {
        this.classBoutonDispo[niveauDispo[0]] = '';
      } else if (el === 2) {
        this.classBoutonDispo[niveauDispo[1]] = '';
      } else if (el === 3) {
        this.classBoutonDispo[niveauDispo[2]] = '';
      }
    });
  },
  methods: {
    ...VenteFacesLc.mapMutations({
      setAddFilterProperty: types.ADD_FILTER_PROPERTY,
    }),
    ...VenteFacesLc.mapActions({
      actionsGestionFiltres: 'gestionFiltres',
    }),
    modifierDispo(valeur, proprieteClass) {
      if (!this.disponibiliteAvailability) {
        return;
      }
      if (this.disponibilite.includes(valeur)) {
        this.disponibilite.splice(this.disponibilite.indexOf(valeur), 1);
        this.classBoutonDispo[proprieteClass] = 'is-outlined';
      } else {
        this.disponibilite.push(valeur);
        this.classBoutonDispo[proprieteClass] = '';
      }
      this.actionsGestionFiltres();
    },
    donneClassCssInitiale() {
      return {
        estIndisponible: 'is-outlined',
        estDisponible: 'is-outlined',
        estPartiellementDisponible: 'is-outlined',
      };
    },
    initialiseFiltreDispo(value) {
      this.setAddFilterProperty({ property: 'dispo', valueProperty: { variable: 'niveauDisponibilite', valeur: value, applicableEnfant: true } });
    },
  },
};
</script>

<style scoped>
  a.button{
    margin: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/filtres/disponibilite.vue